// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030919/js/" + chunkId + "." + {"44":"ce7e7bc0","225":"b717e356","481":"7607ca53","486":"22d96d8a","770":"08bb440a"}[chunkId] + ".0.8506760604878155.chunk.js";
};